import React from 'react';
import GlobalNavbar from '@/components/GlobalNavbar';
import { ShieldCheck, AlertTriangle, Building2 } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';

export default function ComplianceDashboard() {
  const { toast } = useToast();
  
  return (
    <div className="min-h-screen bg-[#F8FAFB]">
      <GlobalNavbar />
      <main className="max-w-7xl mx-auto p-6 space-y-6 mt-8">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-[#193D6D]">Compliance & Auditoria</h1>
            <p className="text-gray-500 mt-1">Gestão de conformidade B2B.</p>
          </div>
          <button 
            onClick={() => toast({ title: 'Nova Auditoria', description: '🚧 Em desenvolvimento.' })}
            className="bg-[#193D6D] text-white px-4 py-2 rounded-md hover:bg-[#112739]"
          >
            Agendar Auditoria
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
            <div className="p-4 rounded-lg bg-blue-50 text-blue-500"><ShieldCheck size={24} /></div>
            <div><p className="text-sm font-medium text-gray-500">Auditorias Ativas</p><p className="text-2xl font-bold text-[#193D6D]">4</p></div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
            <div className="p-4 rounded-lg bg-red-50 text-red-500"><AlertTriangle size={24} /></div>
            <div><p className="text-sm font-medium text-gray-500">Apontamentos Abertos</p><p className="text-2xl font-bold text-[#193D6D]">18</p></div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
            <div className="p-4 rounded-lg bg-gray-100 text-gray-600"><Building2 size={24} /></div>
            <div><p className="text-sm font-medium text-gray-500">Clientes B2B</p><p className="text-2xl font-bold text-[#193D6D]">35</p></div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <h2 className="text-xl font-bold text-[#193D6D] mb-4">Cronograma de Auditorias</h2>
          <div className="text-center py-12 text-gray-500 italic">Nenhuma auditoria agendada.</div>
        </div>
      </main>
    </div>
  );
}